/**
 * Elevation-based shadow tokens for PrimeNG & TailwindCSS.
 *
 * Each level uses two layers: a tight "contact" shadow + a wider "ambient" shadow.
 * As elevation increases, shadows get wider/softer and the opacity decreases —
 * close to the surface = sharper & darker, floating high = diffused & lighter.
 *
 * Reserved for PrimeNG overlays only (tooltips, dropdowns, modals, drawers).
 * Cards and panels use shadow: none — elevation via bg contrast instead.
 */
export const boxShadow = {
  sm: '0px 1px 2px 0px rgba(0,0,0,0.12), 0px 4px 8px 0px rgba(0,0,0,0.08)',
  md: '0px 2px 4px -1px rgba(0,0,0,0.10), 0px 8px 20px -4px rgba(0,0,0,0.10)',
  lg: '0px 4px 8px -2px rgba(0,0,0,0.08), 0px 16px 40px -8px rgba(0,0,0,0.12)',
};